/* eslint-disable max-lines */
import * as React from 'react';

export const Camera = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="79" height="73">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#1A5A97" d="M11 52h12.986a2.464 2.464 0 0 0 2.22-1.368L32 39" />
      <path stroke="#D35043" d="M62 30l-5.43 13L52 40.933M45 37L18 25" />
      <path
        stroke="#D35043"
        d="M58.156 28.49L49.857 47 17.48 32.705a2.474 2.474 0 0 1-1.312-1.368 2.45 2.45 0 0 1 .046-1.889l6.259-13.985a2.487 2.487 0 0 1 3.275-1.25L70 33.734M11 45v13"
      />
      <path stroke="#1A5A97" d="M1 13V1h12M1 60v12h12m65-12v12H66m12-59V1H66" />
    </g>
  </svg>
);
export const Materials = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#0B4F91" d="M13 21.742V1h61v36" />
      <path stroke="#D35043" d="M1 70V22h51v15.32" />
      <path
        stroke="#D35043"
        d="M1 70v-8h17v8m0 0v-8h15v8M10 52h17v10H10zM1 22h17v10H1zm17 0h17v10H18zm17 0h17v10H35zM1 42h17v10H1zm17 0h15v10H18zm-8-10h17v10H10zm23.272 10H27V32h17v5.944"
      />
      <path stroke="#0B4F91" d="M33 70V37h58v33M80 37v33M68 37v33M56 37v33M44 37v33" />
    </g>
  </svg>
);
export const Entrance = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="85" height="80">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1 1)">
      <path stroke="#D35043" d="M34 8h15v16H34zm24 0h15v16H58z" />
      <path stroke="#1A5A97" d="M83 39V0H24v39" />
      <path stroke="#D35043" d="M36 78V43h36v35" />
      <path stroke="#D35043" d="M41 79V49h26v30M41 54h26m-13 0v24" />
      <circle cx="48" cy="66" r="2" stroke="#D35043" />
      <circle cx="60" cy="66" r="2" stroke="#D35043" />
      <path stroke="#D35043" d="M41 8v16M66 8v16m-32 0h15v6H34zm24 0h15v6H58z" />
      <path stroke="#1A5A97" d="M24 36h59m0 42V35m-59 0v36M7 56v15m4 4h10" />
      <path stroke="#D35043" d="M22 71L4.591 53.776a2.72 2.72 0 0 0-3.805 0 2.643 2.643 0 0 0 0 3.761l2.067 2.033" />
      <circle cx="23.5" cy="74.5" r="3.5" stroke="#D35043" />
      <circle cx="6.5" cy="74.5" r="3.5" stroke="#D35043" />
    </g>
  </svg>
);
export const Lobby = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="73">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1 1)">
      <path stroke="#155795" d="M44 0a5 5 0 1 1-10 0" />
      <path stroke="#D35043" d="M39 8v2m-4-3l-1 2m-1-4l-2 2m12 0l1 2m1-4l2 2M30 28h17v31H30z" />
      <path stroke="#155795" d="M61 14L78 0M61 59l17 12M17 14L0 0m17 59L0 71m17-57h44v45H17z" />
      <circle cx="42" cy="46" r="2" stroke="#D35043" />
      <path stroke="#D35043" d="M0 0h78v71H0z" />
    </g>
  </svg>
);
export const HouseBlocks = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#D35043" d="M13 51h17v20H13zm0 15h17m19-49h24" />
      <path stroke="#105393" d="M12 11h7v20h-7zm0 15h7m4-15h7v20h-7zm0 15h7m36 25h7v20h-7zm0 15h7" />
      <path stroke="#D35043" d="M23 51v15m26-55h24v20H49zm17 0v20" />
      <path stroke="#105393" d="M49 51h13v20H49zm0 15h13M0 41h82M41 1v80" />
      <path stroke="#105393" d="M1 1h80v80H1z" />
    </g>
  </svg>
);
export const Ruler = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="68">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1 1)">
      <path stroke="#105393" d="M6 43h10.737c6.748.016 12.235-5.353 12.263-12" />
      <path stroke="#D35043" d="M21 0h40v63z" />
      <path stroke="#105393" d="M40 10h10v17z" />
      <path stroke="#D35043" d="M12 20v-6m-2 17L0 65m13-34l10 34" />
      <circle cx="11.5" cy="25.5" r="5.5" stroke="#105393" />
      <path stroke="#D35043" d="M52 50l4-3m-8-4l3-2m-7-4l4-3m-8-4l3-2m-7-4l4-3m-9-4l3-2m-7-4l4-3" />
    </g>
  </svg>
);
export const Houses = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="85">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#D35043" d="M14 84V6h23v27.6M14 84V6H1v78" />
      <path stroke="#D35043" d="M22 13h7v7h-7zm0 14h7v7h-7zm0 15h7v7h-7zm0 14h7v7h-7zm0 14h7v7h-7z" />
      <path stroke="#1A5A97" d="M49 85V34h32v51m-51 0V34h19v51" />
      <path stroke="#D35043" d="M56 40h6v8h-6zm13 0h6v8h-6zM56 55h6v8h-6z" />
      <path stroke="#1A5A97" d="M37 85V74h5v11" />
      <path stroke="#D35043" d="M69 55h6v8h-6zM56 70h6v8h-6zm13 0h6v8h-6z" />
      <path
        stroke="#165795"
        d="M63 7c2.498 1.575 3.996 4.196 4 7m4-7c-2.498 1.575-3.996 4.196-4 7M50 1c2.498 1.575 3.996 4.196 4 7m4-7c-2.498 1.575-3.996 4.196-4 7"
      />
    </g>
  </svg>
);
export const Sun = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="87" height="86">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <circle cx="43" cy="43" r="27" stroke="#D35043" />
      <circle cx="43" cy="43" r="22" stroke="#D35043" />
      <path stroke="#1A5A97" d="M43 75v11M20 66l-7 7m-2-30H0m20-23l-7-7m30-2V0m23 20l7-7m3 30h11M66 66l7 7" />
    </g>
  </svg>
);
export const Eye = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="122" height="88">
    <g fill="none" fillRule="evenodd">
      <path fill="#E8F0F5" d="M0 0h122v88H0z" opacity=".01" />
      <circle cx="62" cy="49" r="22" stroke="#155795" strokeWidth="1.95" />
      <path
        stroke="#155795"
        strokeWidth="1.95"
        d="M62 27V16m15 12l3-10m11 16l5-9m7 18l7-6m-64-9l-3-10M32 34l-5-9m-6 18l-7-6"
      />
      <ellipse cx="62" cy="49" stroke="#D35043" strokeWidth="1.95" rx="43" ry="22" />
      <circle cx="62" cy="49" r="9" stroke="#D35043" strokeWidth="1.95" />
    </g>
  </svg>
);
export const Paint = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="88">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path
        stroke="#D35043"
        d="M78.18 44.307l4.05-4.005m-14.27-6.101l6.86-6.783m-17.09-3.322l10.06-9.947m-20.28-.158L60.97.682"
      />
      <path
        stroke="#155795"
        d="M62.56 57.862l7.06-22.148M51.33 46.759l7.06-22.149M40.11 35.655l7.06-22.148M29 58.762l1-.989a6.727 6.727 0 0 1 8.51-.76l25.39 17.4a6.656 6.656 0 0 0 8.41-.751l5.84-5.774a6.474 6.474 0 0 0 0-9.216l-2.83-2.788"
      />
      <rect
        width="14.16"
        height="33.638"
        x="9.861"
        y="53.84"
        stroke="#D35043"
        rx="2.57"
        transform="rotate(-135 16.941 70.659)"
      />
      <rect
        width="57.78"
        height="20.596"
        x="25.974"
        y="25.399"
        stroke="#D35043"
        rx="2.76"
        transform="rotate(-135 54.864 35.697)"
      />
    </g>
  </svg>
);
export const Room = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="79" height="91">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#1A5A97" d="M29 41.007L11 50.89V29.482L29 19.6zm34 19.66V25.994L51 19.6v34.673M20 24.489v20.533" />
      <path stroke="#D35043" d="M39 2v45.496L1 68.489m38-20.533l38 20.533" />
      <path stroke="#1A5A97" d="M1 68.14V22.883L39.505 2 78 22.883V68.14L39.505 89.022z" />
    </g>
  </svg>
);
export const Clean = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="81" height="72">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1 1)">
      <path stroke="#105393" d="M44 4h24v16" />
      <path stroke="#626577" d="M16 4h18" />
      <path stroke="#105393" d="M12 1v57l42-.15" />
      <path stroke="#105393" d="M54 70H0V1h16v53h38z" />
      <path
        stroke="#D35043"
        d="M79 69V41c.003-.584-.296-1.625-1-3l-3-5c-1.35-1.53-1.891-3.37-2-5v-3h3c.673.264 1.479-.066 2-1 .666-.239 1-1.034 1-2 0-1.592-1.416-2.994-3-3H54l-3 2c.127.473 0 .763 0 1 0 .37.127.66 0 1l3 2h9c1.34 3.933.978 8.392-1 12l-7 10c-.853.646-1.171 1.659-1 3v19c-.168.378.467 1 1 1h23c.36 0 .994-.622 1-1z"
      />
      <path stroke="#D35043" d="M59 19v6.036L55 34m8-3h10m6 11l-23 4" />
      <circle cx="38.5" cy="4.5" r="4.5" stroke="#D35043" />
      <circle cx="42.5" cy="27.5" r="3.5" stroke="#D35043" />
      <circle cx="30.5" cy="43.5" r="3.5" stroke="#D35043" />
      <path stroke="#D35043" d="M28 16v-4m2 6h4m-6 1v4m-2-5h-4" />
    </g>
  </svg>
);
export const Window = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="80">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path
        stroke="#1A5A97"
        d="M71 41.554c-2.768-3.28-6.93-3.466-10.098-.176-4.633-.312-7.54 2.587-7.27 6.835-3.38 2.694-3.57 6.122-.19 8.787"
      />
      <path stroke="#D35043" d="M63 21l-5 5m-34-6l-6 6m17-9l-9 9m37-14L49 26" />
      <path stroke="#155795" d="M41 6v52M62.766 1H6v56h70V1z" />
      <path stroke="#155795" d="M11 6h60v52H11z" />
      <path stroke="#D35043" d="M1 58h81v5H1z" />
      <path stroke="#155795" d="M7 80V69h69v11m0-7H7" />
    </g>
  </svg>
);
export const Conditioning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="74" height="76">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#D35043" d="M55 1h11v8H55zm6 0v8" />
      <path stroke="#155795" d="M5 42V14h65v28" />
      <path
        stroke="#155795"
        d="M11 42c0-12.15 10.074-22 22.5-22S56 29.85 56 42m-29 0a6 6 0 1 1 12 0m-8 0a2 2 0 1 1 4 0"
      />
      <path
        stroke="#155795"
        d="M31.73 36C29.512 36 29 29.596 29 27.243 29 24.9 30.79 23 33 23s4 1.9 4 4.243C37 29.596 36.488 36 34.27 36M39 40.723C39 38.52 45.41 38 47.75 38c1.127 0 2.208.421 3.005 1.172A3.885 3.885 0 0 1 52 42m-37 0c0-2.205 1.896-3.995 4.24-4 2.35 0 8.76.52 8.76 2.723M55 19h11v6H55zM1 9h72v5H1z"
      />
      <path stroke="#D35043" d="M1 42h72v33H1zm68 6H5m64 7H5m64 14H5m64-7H5" />
    </g>
  </svg>
);
export const Box = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#105393" d="M80.4 35.618L90 19.89 55.6 2 46 17.718m-34.4 17.9L2 19.89 36.4 2 46 17.718" />
      <path stroke="#D35043" d="M58 57.37l13-6.92m-37 6.92l-13-6.92" />
      <path stroke="#105393" d="M46 54.404v34.607M12 36.607l34 17.797m34-17.797L46 54.404" />
      <path stroke="#D35043" d="M81 35.878v36.065L46.5 90 12 71.943V35.878L46.5 17.82z" />
    </g>
  </svg>
);
export const Plan = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="77">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#D35043" d="M33 31v8m0-26V5m38 34H59m-17 0H5M57 5c.264 9.54-5.884 13.677-13 14V5H5v67h66V5H57z" />
      <path stroke="#0B4F91" d="M57 1h18v75H1V1h44" />
    </g>
  </svg>
);
export const Tree = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="83">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1)">
      <path stroke="#0B4F91" d="M67 25v8m6-10l6 6m-3-12h8m-11-6l6-6M67 8V0m-5 11l-6-6m3 12h-8m11 6l-6 6" />
      <path
        stroke="#D35043"
        d="M31 17.008c-4.286-5.142-10.736-5.441-15.662-.29-7.19-.489-11.68 4.044-11.253 10.684-5.24 4.213-5.546 9.585-.295 13.788-.497 6.17 4.063 9.685 10.858 9.325.99 2.115 3.137 3.473 5.505 3.485"
      />
      <path
        stroke="#D35043"
        d="M15 17.005c4.296-5.138 10.735-5.437 15.66-.29 7.171-.488 11.68 4.042 11.264 10.676 5.23 4.21 5.535 9.578.285 13.808.497 6.166-4.063 9.678-10.857 9.319-.99 2.113-3.137 3.47-5.505 3.482"
      />
      <path stroke="#064B8F" d="M23 31v52M8 75c2.488 1.8 3.985 4.793 4 8m-1-13c3.776 3.068 6 7.884 6 13" />
      <path stroke="#D35043" d="M35 56v15m0 6v6m52-6v6m0-27v15m0-12H35m52 6H35m2.921 6H90v6H32v-6z" />
      <circle cx="67" cy="16" r="8" stroke="#D35043" />
    </g>
  </svg>
);
export const Car = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="87" height="60">
    <g fill="none" fillRule="evenodd" transform="translate(1 3)">
      <path
        stroke="#105493"
        strokeWidth="1.95"
        d="M29 3v18m0 23h23m30-8v5.026C82 43.22 80.38 45 78.383 45H72M8.693 44l-5.41-2.002A5.004 5.004 0 0 1 0 37.332V23.735a7.394 7.394 0 0 1 1.293-4.265L11.418 4.822A4.208 4.208 0 0 1 14.918 3h30.364c1.547.016 3 .756 3.928 2.003l12.322 16.37 17.564 4.104A3.78 3.78 0 0 1 82 29.162v1.582M62 22H0"
      />
      <circle cx="19" cy="44" r="10" stroke="#105493" strokeWidth="1.95" />
      <circle cx="62" cy="44" r="10" stroke="#105493" strokeWidth="1.95" />
      <path
        stroke="#105493"
        strokeWidth="1.95"
        d="M83 31h-3.05a1.972 1.972 0 0 0-1.378.546 1.847 1.847 0 0 0-.572 1.33v1.248c0 .5.206.978.572 1.33a1.97 1.97 0 0 0 1.377.546H83"
      />
      <path
        stroke="#105493"
        strokeWidth="1.95"
        d="M82 35.995c1.048.06 2.047-.401 2.591-1.198a2.262 2.262 0 0 0 0-2.594c-.544-.797-1.543-1.258-2.591-1.198"
      />
      <path stroke="#E8F0F5" strokeWidth="6" d="M63 0L9 54" />
      <path stroke="#D35043" strokeWidth="1.95" d="M61 2L9 54" />
    </g>
  </svg>
);
export const GreenStreet = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="73">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1)">
      <path stroke="#135594" d="M72 73V11H54v27.957" />
      <path stroke="#105393" d="M54 54v19m26 0V57m0-.076V11h-8v62" />
      <path
        stroke="#D35043"
        d="M66 38h-6v-7h6zm0 14h-6v-7h6zm0-28h-6v-7h6zm0 42h-6v-7h6zM49 37.066c-2.348-2.75-5.882-2.76-8.58 0-3.935-.257-6.407 2.167-6.18 5.718-2.874 2.256-3.04 5.135-.165 7.4-.268 3.304 2.245 5.184 5.953 4.946.542 1.135 1.72 1.864 3.018 1.87"
      />
      <path
        stroke="#D35043"
        d="M40 37.066c2.346-2.75 5.875-2.76 8.57 0 3.93-.257 6.4 2.167 6.173 5.718 2.87 2.256 3.087 5.135.165 7.4.267 3.304-2.253 5.184-5.947 4.946-.545 1.131-1.718 1.86-3.014 1.87"
      />
      <path stroke="#105393" d="M44 44v29m0-22l4-4m-4 4l-4-4" />
      <path
        stroke="#D35043"
        d="M9 37.06c2.348-2.742 5.882-2.752 8.58 0 3.935-.257 6.407 2.16 6.18 5.7 2.874 2.248 3.04 5.118.165 7.376.268 3.294-2.256 5.168-5.953 4.931-.523 1.151-1.697 1.906-3.008 1.933"
      />
      <path
        stroke="#D35043"
        d="M17 37.064c-2.212-2.747-5.539-2.757-8.08 0-3.705-.257-6.033 2.163-5.82 5.71-2.696 2.282-2.851 5.157-.145 7.42-.252 3.299 2.114 5.176 5.606 4.939A3.14 3.14 0 0 0 11.403 57"
      />
      <path stroke="#105393" d="M13 44v29m0-22l-4-4m4 4l4-4" />
      <path stroke="#185896" d="M36 17v6m-4-8l-4 4m2-8h-6m8-4l-4-4m8 3V0m4 7l4-4m-3 8h6m-7 4l4 4" />
      <circle cx="35.5" cy="11.5" r="5.5" stroke="#D35043" />
      <path
        stroke="#105393"
        d="M16 25c2.502 1.572 4.001 4.195 4 7m4-7c-2.498 1.575-3.996 4.196-4 7M3 19c2.503 1.573 4.002 4.196 4 7m4-7c-2.5 1.572-3.998 4.194-4 7M0 67c1.88 1.345 3.004 3.594 3 6M2 63a12.453 12.453 0 0 1 5 10"
      />
    </g>
  </svg>
);
export const Bike = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="77">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path stroke="#0B4F91" d="M81 68h11m-58 0h21M0 68h8" />
      <path stroke="#064B8F" d="M15 28v20" />
      <path
        stroke="#D35043"
        d="M15 0v3m11 4l-2 2M5 6l2 2m3.153 7.712L12.372 22h5.474l2.027-6.327a2.68 2.68 0 0 0-.74-2.79l-2.363-2.18a2.634 2.634 0 0 0-3.582 0l-2.324 2.15a2.67 2.67 0 0 0-.711 2.859z"
      />
      <path stroke="#064B8F" d="M12 27h6" />
      <circle cx="67.5" cy="61.5" r="14.5" stroke="#D35043" />
      <circle cx="20.5" cy="61.5" r="14.5" stroke="#D35043" />
      <path stroke="#D35043" d="M37 40h24m-26-5l9 27m24 0L57.956 32.882A2.82 2.82 0 0 0 55.297 31H52m-21 4h9" />
      <path stroke="#D35043" d="M61 40L44.794 62H21l16.206-22" />
    </g>
  </svg>
);
export const Yard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="86" height="73">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95" transform="translate(1)">
      <path stroke="#01478D" d="M30 73V11H0v62" />
      <path stroke="#064B8F" d="M46 73V57" />
      <path stroke="#01478D" d="M46 40.295V11H30v62" />
      <path
        stroke="#D35043"
        d="M24 38h-6v-7h6zm-12 0H6v-7h6zm12 14h-6v-7h6zm-12 0H6v-7h6zm12-28h-6v-7h6zm-12 0H6v-7h6zm12 42h-6v-7h6zm-12 0H6v-7h6zm35-25.124c2.08-2.501 5.197-2.501 7.58 0 3.468-.238 5.65 1.985 5.448 5.191 2.533 2.045 2.674 4.655.141 6.71.241 2.977-2.01 4.704-5.258 4.536A2.938 2.938 0 0 1 52.247 59"
      />
      <path
        stroke="#D35043"
        d="M55 40.876c-2.08-2.501-5.196-2.501-7.578 0-3.467-.238-5.648 1.985-5.447 5.191-2.532 2.045-2.683 4.655-.14 6.71-.242 2.977 2.01 4.704 5.256 4.536A2.937 2.937 0 0 0 49.754 59"
      />
      <path stroke="#01478D" d="M51 47v26m0-20l-4-4m4 4l4-4" />
      <path
        stroke="#D35043"
        d="M69 40.876c2.07-2.501 5.197-2.501 7.58 0 3.468-.238 5.65 1.985 5.448 5.191 2.533 2.045 2.674 4.655.141 6.71.241 2.977-2.01 4.704-5.258 4.536A2.938 2.938 0 0 1 74.247 59"
      />
      <path
        stroke="#D35043"
        d="M77 40.876c-2.08-2.501-5.196-2.501-7.578 0-3.467-.238-5.648 1.985-5.447 5.191-2.532 2.045-2.683 4.655-.14 6.71-.242 2.977 2.01 4.704 5.256 4.536A2.937 2.937 0 0 0 71.754 59"
      />
      <path stroke="#01478D" d="M73 47v26m0-20l-4-4m4 4l4-4" />
      <path stroke="#064B8F" d="M64 17v6m4-8l4 4m-3-8h6m-7-4l4-4m-8 3V0m-4 7l-4-4m2 8h-6m8 4l-4 4" />
      <circle cx="63.5" cy="11.5" r="5.5" stroke="#D35043" />
    </g>
  </svg>
);
export const Playground = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="79" height="75">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path
        stroke="#D35043"
        d="M57 59.415c2.627-3.095 6.579-3.28 9.59-.176 4.406-.283 7.165 2.44 6.912 6.433 3.203 2.548 3.395 5.78.172 8.328"
      />
      <path stroke="#01478D" d="M56 74V15L44 2H34v5h10V2" />
      <path
        stroke="#D35043"
        d="M39 18l.03-3M48 15l-2-2m-16 2l2-2m2 29v32m-16 0c14.511.06 6.407-35.06 23-35M0 74c12.18 0 7.056-35.06 21-35m24 27.02L34 66m11-8.98L34 57m11-8.98L34 48M23 32a3 3 0 0 1 6 0m-5.99 0L23 34m6.01-2L29 34.012V39m10.005-6c-.063-1.051.494-2.049 1.446-2.592a3.146 3.146 0 0 1 3.098 0c.952.543 1.509 1.54 1.446 2.592M39 33v1m6-1v41M21 39h24"
      />
      <path
        stroke="#01478D"
        d="M70 11c2.503 1.573 4.002 4.196 4 7m4-7c-2.5 1.572-3.998 4.194-4 7M59 1c2.498 1.575 3.996 4.196 4 7m4-7c-2.502 1.572-4.001 4.195-4 7"
      />
    </g>
  </svg>
);
export const Infrastructure = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="89">
    <g fill="none" fillRule="evenodd" strokeWidth="1.95">
      <path
        stroke="#01478D"
        d="M19 83h47c7.056-.006 13-5.939 13-13-.006-7.57-5.948-13.497-13-14H53c-6.251.498-11.303-4.54-11-11-.303-2.74.886-5.601 3-8 2.119-1.82 4.989-3.003 8-3h21"
      />
      <circle cx="45.5" cy="83.32" r="4.34" fill="#E8F0F5" fillRule="nonzero" stroke="#D35043" />
      <circle cx="78.33" cy="70.75" r="4.34" fill="#E8F0F5" fillRule="nonzero" stroke="#D35043" />
      <circle cx="41.17" cy="45.61" r="4.34" fill="#E8F0F5" fillRule="nonzero" stroke="#D35043" />
      <circle cx="78.33" cy="13.34" r="4.34" stroke="#D35043" />
      <circle cx="13.26" cy="62.08" r="4.34" stroke="#D35043" />
      <path
        stroke="#D35043"
        d="M25.54 62.2c0 6.78-12.28 21.12-12.28 21.12S1 69 1 62.2a12.29 12.29 0 1 1 24.57 0h-.03zm65.07-48.94c0 6.78-12.28 21.12-12.28 21.12S66.05 20 66.05 13.26C66.05 6.478 71.548.98 78.33.98c6.782 0 12.28 5.498 12.28 12.28z"
      />
    </g>
  </svg>
);
export const Check = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fill="#2E9E00"
      fillRule="nonzero"
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
    />
  </svg>
);

export const TABS_ICONS: { [key: string]: { description?: string; icon: React.ReactNode }[] } = {
  yardPark: [
    {
      description: 'Современное благоустройство',
      icon: <Tree />,
    },
    {
      description: 'Развитая инфраструктура',
      icon: <Infrastructure />,
    },
    {
      description: 'Площадки для досуга',
      icon: <Playground />,
    },
    {
      description: 'Зеленые бульвары',
      icon: <GreenStreet />,
    },
    {
      description: 'Дворы без машин',
      icon: <Car />,
    },
    {
      description: 'Велодорожки',
      icon: <Bike />,
    },
    {
      description: 'Безопасный двор',
      icon: <Yard />,
    },
  ],
  decoration: [
    {
      description: 'Функциональные планировки',
      icon: <Plan />,
    },
    {
      description: 'Современные профили',
      icon: <Clean />,
    },
    {
      description: 'Светлая квартира',
      icon: <Sun />,
    },
    {
      description: 'Практичность и комфорт',
      icon: <Conditioning />,
    },
    {
      description: 'Персональные кладовые',
      icon: <Box />,
    },
    {
      description: 'Низкие подоконники',
      icon: <Window />,
    },
    {
      description: 'Нейтральный дизайн',
      icon: <Paint />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Гармоничные пропорции',
      icon: <Room />,
    },
    {
      description: 'В едином стиле',
      icon: <Eye />,
    },
  ],
  facades: [
    {
      description: 'Практичность и комфорт',
      icon: <Conditioning />,
    },
    {
      description: 'Много света',
      icon: <Sun />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Индивидуальная архитектура',
      icon: <Ruler />,
    },
    {
      description: 'Долговечные материалы',
      icon: <HouseBlocks />,
    },
    {
      description: 'Динамичный облик',
      icon: <Houses />,
    },
    {
      description: 'В едином стиле',
      icon: <Eye />,
    },
  ],
  elevators: [
    {
      description: 'Просторные холлы',
      icon: <Lobby />,
    },
    {
      description: 'Практичность и комфорт',
      icon: <Conditioning />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Долговечные материалы',
      icon: <HouseBlocks />,
    },
  ],
  entrances: [
    {
      description: 'Просторные холлы',
      icon: <Lobby />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Индивидуальная архитектура',
      icon: <Ruler />,
    },
    {
      description: 'Безопасность',
      icon: <Camera />,
    },
    {
      description: 'Без ступеней и пандусов',
      icon: <Entrance />,
    },
  ],
  sockets: [
    {
      description: 'Функциональные планировки',
      icon: <Plan />,
    },
    {
      description: 'Практичность и комфорт',
      icon: <Conditioning />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'В едином стиле',
      icon: <Eye />,
    },
  ],
  lobby: [
    {
      description: 'Просторные холлы',
      icon: <Lobby />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Долговечные материалы',
      icon: <HouseBlocks />,
    },
    {
      description: 'Безопасность',
      icon: <Camera />,
    },
    {
      description: 'Без ступеней и пандусов',
      icon: <Entrance />,
    },
  ],
  steps: [
    {
      description: 'Просторные холлы',
      icon: <Lobby />,
    },
    {
      description: 'Практичность и комфорт',
      icon: <Conditioning />,
    },
    {
      description: 'Много света',
      icon: <Sun />,
    },
    {
      description: 'Качественные материалы',
      icon: <Materials />,
    },
    {
      description: 'Индивидуальная архитектура',
      icon: <Ruler />,
    },
    {
      description: 'Долговечные материалы',
      icon: <HouseBlocks />,
    },
    {
      description: 'Безопасность',
      icon: <Camera />,
    },
    {
      description: 'Без ступеней и пандусов',
      icon: <Entrance />,
    },
  ],
  howItsDone: [],
  playability: [],
};
